import { IAppointment } from '@/service/types'
import { getInterval } from '@/utils'
import { Box, Chip, Tooltip } from '@mui/material'
import React from 'react'

interface IAppointmentButton {
  appointment: IAppointment
  clientId: string
  service: string
  handleTimeslotClick: (
    appointment: string,
    service: string,
    startDate: string,
    endDate: string,
    action: 'bookAppointment' | 'releaseAppointment',
  ) => void
}

const _AppointmentButton = (props: IAppointmentButton) => {
  const { appointment, clientId, service, handleTimeslotClick } = props
  const { isLocked, visitor, id, startDate, endDate, status } = appointment
  const isMyBookingConfirmed = isLocked && visitor === clientId
  const isAppointmentTakenBySomeone = status === 'BOOKED' || (isLocked && visitor !== clientId)

  const clickAction = isMyBookingConfirmed ? 'releaseAppointment' : 'bookAppointment'

  return (
    <Tooltip
      title={isLocked && visitor !== clientId ? 'Valaki éppen foglalja ezt az időpontot.' : ''}
    >
      <Box p={0.5}>
        <Chip
          variant="outlined"
          color={isMyBookingConfirmed ? 'primary' : 'default'}
          onClick={() => {
            if (!isAppointmentTakenBySomeone) {
              handleTimeslotClick(id, service, startDate, endDate, clickAction)
            }
          }}
          disabled={isAppointmentTakenBySomeone}
          label={getInterval(startDate, endDate)}
        />
      </Box>
    </Tooltip>
  )
}

/* 
  For performance gains: 
  Only re-render Button component if it's booked and the time is ticking.
  If it has expiresAt, then return with false, so it will trigger a new render,
  otherwise compare the props and if nothing has changed, skip the render.
*/
function compareButtonProps(prev: IAppointmentButton, next: IAppointmentButton) {
  if (prev.appointment.expiresAt || next.appointment.expiresAt) {
    return false
  }

  return (
    prev.service === next.service &&
    prev.clientId === next.clientId &&
    JSON.stringify(prev.appointment) === JSON.stringify(next.appointment)
  )
}

export const AppointmentButton = React.memo(_AppointmentButton, compareButtonProps)
